import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { NOTIFICATION_CONSTANT } from '@client/app/modules/notifications/constant/notification.constant';

@Pipe({
    name: 'notificationAction',
    standalone: true,
})
export class NotificationActionPipe implements PipeTransform {
    constructor (private readonly translocoService: TranslocoService) { }

    transform (args: string[]): string {
        const action = args[0];
        const target = args[1];
        const stage = args[2];

        if (stage === NOTIFICATION_CONSTANT.STAGE.DONE) {
            switch (action) {
                case NOTIFICATION_CONSTANT.ACTION.COOKIES_FOUND:
                    return this.translocoService.translate('notifications.actions.cookiesFound');
                case NOTIFICATION_CONSTANT.ACTION.ACCESSIBILITY_ERRORS_IGNORED:
                case NOTIFICATION_CONSTANT.ACTION.ACCESSIBILITY_CHECK_IGNORED:
                case NOTIFICATION_CONSTANT.ACTION.IGNORED:
                case NOTIFICATION_CONSTANT.ACTION.HIDDEN:
                    return this.translocoService.translate('notifications.actions.ignored');
                case NOTIFICATION_CONSTANT.ACTION.ACCESSIBILITY_CHECK_REVIEWED:
                case NOTIFICATION_CONSTANT.ACTION.REVIEWED:
                    return this.translocoService.translate('notifications.actions.reviewed');
                case NOTIFICATION_CONSTANT.ACTION.DEAD:
                    return this.translocoService.translate('notifications.actions.dead');
                case NOTIFICATION_CONSTANT.ACTION.REQUEST_SCAN:
                    return this.translocoService.translate('notifications.actions.scan');
                case NOTIFICATION_CONSTANT.ACTION.CRAWL_DONE:
                    return this.translocoService.translate('notifications.actions.crawlDone');
                case NOTIFICATION_CONSTANT.ACTION.CRAWL_FINALIZED:
                    return this.translocoService.translate('notifications.actions.crawlFinalized');
                case NOTIFICATION_CONSTANT.ACTION.FIXED:
                    return this.translocoService.translate('notifications.actions.fixed');
                case NOTIFICATION_CONSTANT.ACTION.UPDATE:
                    return this.translocoService.translate('notifications.actions.updated');
                case NOTIFICATION_CONSTANT.ACTION.CREATE:
                    switch (target) {
                        case NOTIFICATION_CONSTANT.TARGET.SPELLING_IGNORED:
                            return this.translocoService.translate('notifications.actions.ignored');
                        case NOTIFICATION_CONSTANT.TARGET.SPELLING_CONFIRMED:
                            return this.translocoService.translate('notifications.actions.confirmed');
                        case NOTIFICATION_CONSTANT.TARGET.SPELLING_DICTIONARY:
                            return this.translocoService.translate('notifications.actions.added');
                        case NOTIFICATION_CONSTANT.TARGET.REQUEST_SCAN:
                            return this.translocoService.translate('notifications.actions.requested');
                        default:
                            return this.translocoService.translate('notifications.actions.created');
                    }
                default:
                    return '';
            }
        }
        return '';
    }
}
